import React from 'react';

const Loading = () => {
    return (
        <div style={{ display: 'grid', placeItems: 'center', height: '200px' }}>Cargando...</div>
    );
}

export default Loading;
